import React, { useState } from 'react';
import './RadioboxComponent.css';

const RadioboxComponent = ({
    uniqueId,
    label,
    checked,
    onChange,
    name,
    error,
    disabled = false,
    style = {},
    ...props
}) => {

    const handleChange = (e) => {
        onChange && onChange(e);
    };

    return (
        <div className="radio-box-container" style={style}>
            <div className="radio-box-wrapper">
                <label className={`radio-box-label ${error ? 'error' : ''} ${disabled ? 'disabled' : ''}`}>
                    <input
                        id={uniqueId}
                        type="radio"
                        checked={checked}
                        onChange={handleChange}
                        name={name}
                        disabled={disabled}
                        className="radio-box-input"
                        {...props}
                    />
                    <span htmlFor={uniqueId} className="radio-box-custom"></span>
                    {label && <span className="radio-box-label-text">{label}</span>}
                </label>
            </div>
        </div>
    );
};

export default RadioboxComponent;
